exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.action-header {\n  min-width: 250px;\n}\n", ""]);

// exports
